import type { CSSCustomProperties } from "@circleco/compass/components/MobileShell";

const communityHeaderActiveBackgroundVar =
  "var(--color-community-header-active-background)";
const communityHeaderTextVar = "var(--color-community-header-text)";

/**
 * Unread-counter tokens only. Kept applied even on the default theme
 * so the header's counter matches the sidebar's.
 */
export const HEADER_COMPASS_BADGE_THEME_VARS: CSSCustomProperties = {
  "--color-background-inverse":
    "var(--color-community-sidebar-badge-background)",
  "--color-text-inverse": "var(--color-community-sidebar-badge-text)",
};

/** Remaps generic header tokens onto community header colors. Apply via `style` (desktop) or `themeVars` (`MobileShell.Header`). */
export const HEADER_COMPASS_THEME_VARS: CSSCustomProperties = {
  "--color-background-hover": communityHeaderActiveBackgroundVar,
  "--color-background-active": communityHeaderActiveBackgroundVar,
  "--color-icon-primary": communityHeaderTextVar,
  "--color-background-disabled": communityHeaderActiveBackgroundVar,
  "--color-text-primary": communityHeaderTextVar,
  ...HEADER_COMPASS_BADGE_THEME_VARS,
  "--counter-halo-color": "var(--color-community-header-background)",
};

/** Same idea, for the Login/Join auth buttons specifically. */
export const HEADER_AUTH_BUTTON_THEME_VARS: CSSCustomProperties = {
  "--color-background-button-branded": communityHeaderActiveBackgroundVar,
  "--color-text-button-branded": "var(--color-community-header-active-text)",
  "--color-text-primary": communityHeaderTextVar,
  "--color-background-primary": "transparent",
  "--color-border-primary": communityHeaderTextVar,
  "--color-background-active": `color-mix(in srgb, ${communityHeaderTextVar} 18%, transparent)`,
};

/** Mobile-only: `MobileShell.Header` has no `bg-c-header` equivalent class, so remap the generic bg token instead. */
export const MOBILE_HEADER_BACKGROUND_THEME_VARS: CSSCustomProperties = {
  "--color-background-primary": "var(--color-community-header-background)",
};

/**
 * Mobile-only, scoped to the `HeaderBar` wrapping `Tabs.Root` (not
 * `Header`) - shadows the outer bg/text remap so the active pill/label use
 * the active colors instead of blending into the plain header background.
 */
export const MOBILE_SECTION_TABS_THEME_VARS: CSSCustomProperties = {
  "--color-text-tertiary": communityHeaderTextVar,
  "--color-text-primary": "var(--color-community-header-active-text)",
  "--color-background-primary": communityHeaderActiveBackgroundVar,
  "--color-border-primary": communityHeaderActiveBackgroundVar,
};

/** Pair with `HEADER_AUTH_BUTTON_THEME_VARS` on the same wrapper - hover
 * state for the Login button isn't covered by a plain CSS variable since
 * Button's own `:hover` styles don't read `--color-community-header-*`. */
export const HEADER_AUTH_BUTTON_ACTIVE_STATES_CLASS =
  "[&_button:hover]:[--color-text-primary:var(--color-community-header-active-text)]";

/** Desktop-only for now - icon buttons in the mobile shell (drawer trigger,
 * back button) don't yet have an equivalent hover/focus/open state that
 * needs this. */
export const HEADER_ICON_BUTTON_ACTIVE_STATES_CLASS =
  "[&_[data-header-icon-button]:hover]:[--color-text-primary:var(--color-community-header-active-text)] [&_[data-header-icon-button]:focus-visible]:bg-c-header-active [&_[data-header-icon-button]:focus-visible]:[--color-text-primary:var(--color-community-header-active-text)] [&_[data-header-icon-button][data-popup-open]]:bg-c-header-active [&_[data-header-icon-button][data-popup-open]]:[--color-text-primary:var(--color-community-header-active-text)]";
